// export const SET_VACANCIES = 'SET_VACANCIES'
export const FETCH_VACANCIES_REQUEST = 'FETCH_VACANCIES_REQUEST'
export const FETCH_VACANCIES_SUCCES = 'FETCH_VACANCIES_SUCCES'
export const FETCH_VACANCIES_ERROR = 'FETCH_VACANCIES_ERROR'


// WEBPACK FOOTER //
// ./src/constants/Vacancies.js